import { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import { CustomField } from "store/environments/tenants/custom-fields/dooap-types";
import { Tenant } from "store/environments/environment-types";

export const loadCustomFields = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[Tenant<ReadonlyArray<CustomField>> | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `environments/${environmentId}/tenants/${tenantId}/custom-fields/dooap`,
        {
            cancelToken: cancelTokenSource?.token,
        }
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const updateCustomFields = async (
    environmentId: string,
    tenantId: string,
    payload: ReadonlyArray<CustomField>,
    cancelTokenSource?: CancelTokenSource
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.put(
        `environments/${environmentId}/tenants/${tenantId}/custom-fields/dooap`,
        payload,
        {
            cancelToken: cancelTokenSource?.token,
        }
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const removeCustomFields = async (
    environmentId: string,
    tenantId: string,
    payload: ReadonlyArray<CustomField>,
    cancelTokenSource?: CancelTokenSource
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.request({
        method: "DELETE",
        url: `environments/${environmentId}/tenants/${tenantId}/custom-fields/dooap`,
        cancelToken: cancelTokenSource?.token,
        data: payload,
    });

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
